import type { SalonProfile } from '@/types'

import { WhatsAppIcon } from '@/components/site/brand-icons'
import { whatsappLink } from '@/lib/phone'
import { bookingWhatsAppText } from '@/lib/salon'

interface WhatsAppButtonProps {
    profile: SalonProfile
}

export const WhatsAppButton = ({ profile }: WhatsAppButtonProps) => {
    if (!profile.whatsapp) return null

    return (
        <a
            href={whatsappLink(profile.whatsapp, bookingWhatsAppText(profile))}
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Chat with us on WhatsApp'
            className='group fixed right-4 bottom-4 z-30 flex items-center gap-3 rounded-full bg-[#1FAF5A] py-3 pr-3 pl-3 text-white shadow-[0_12px_32px_-10px_rgba(16,94,54,0.65)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#189B4E] focus-visible:ring-4 focus-visible:ring-emerald-300 focus-visible:outline-none sm:right-6 sm:bottom-6 sm:pl-5'
        >
            <span className='hidden text-sm font-semibold sm:inline'>Chat with us</span>
            <span className='flex size-9 items-center justify-center rounded-full bg-white/15'>
                <WhatsAppIcon className='size-5' />
            </span>
        </a>
    )
}
